<template>
    <div class="vehica-inventory-v1">
        <div class="vehica-inventory-v1__top border-bottom-0">
            <div class="vehica-inventory-v1__top__inner pt-3">
                <h3 class="pt-3 text-center">Your Next Ride Awaits!</h3>
                <h5 class="mx-sm-5 text-center">
                    Discover the benefits of buying directly from our private seller inventory.
                </h5>
                <div class="elementor-column elementor-col-50 elementor-top-column elementor-element mx-auto">
                <ul class="list-unstyled mx-sm-5">
                    <li class="">
                        <i class="fa fa-fw fa-car-on text-primary"></i>
                        Vehicles previously owned by private sellers  are often better maintained, with meticulous attention to detail
                    </li>
                    <li class="">
                        <i class="fa fa-fw fa-clipboard-list text-primary"></i>
                        We ensure every car comes with a comprehensive AutoCheck report from Experian
                    </li>
                    <li class="">
                        <i class="fa fa-fw fa-tools text-primary"></i>
                        We provide additional tools and resources so you can feel confident that your next ride from us will be exceptional
                    </li>
                </ul>
                </div>
            </div>
            <div class="vehica-inventory-v1__top__inner pt-3">
                <div class="vehica-inventory-v1__bar">
                    <div class="vehica-inventory-v1__bar__right">
                        <div class="vehica-inventory-v1__keyword" :class="keywords ? 'vehica-inventory-v1__keyword--active' : ''">
                            <input class="border border-1" type="text" maxlength="30" placeholder="Search" v-model="keywords" @change="changed" onfocus="this.select()">
                            <div class="vehica-inventory-v1__keyword__icon">
                                <i class="fas fa-search"></i>
                            </div>
                        </div>
                        <div class="col-3 ms-3 vehica-hide-mobile vehica-hide-tablet">
                            <button class="vehica-form-button py-2 w-auto text-end" style="min-width:153px"
                                    @click="toggleFilters">{{ moreFilters }} <i class="fa ms-1" :class="more ? 'fa-chevron-up' : 'fa-chevron-down'"></i></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="vehica-inventory-v1__mobile-button-options">
            <button @click="toggleMobileFilters(1)">Filters ({{ filters }})</button>
        </div>
        <!-- Search filters -->
        <div v-show="more" class="vehica-inventory-v1__top">
            <div class="vehica-inventory-v1__top__inner">
                <div :class="'vehica-results__fields' + (mobileFilters ? ' vehica-results__fields--mobile-open' : '')">
                    <div class="vehica-results__fields__mobile-section-top">
                        <h3 class="vehica-results__fields__mobile-section-top__title">
                            Filters
                        </h3>
                        <h4 class="vehica-results__fields__mobile-section-top__subtitle">
                            <span class="vehica-results__fields__mobile-section-top__subtitle__number"> {{ count }} </span>
                            <span class="vehica-results__fields__mobile-section-top__subtitle__label"> {{ resultsText }} </span>
                        </h4>
                        <div class="vehica-results__fields__mobile-section-top__close" @click="toggleMobileFilters(0)"><i class="fa fa-times-circle"></i></div>
                    </div>
                    <vehicle-make class="vehica-results__field vehica-relation-field vehica-results__field--relation_show"
                                  :make="make"
                                  :multiselect="true"
                                  :in-stock="inStock"
                                  @input="toggleMakes"></vehicle-make>
                    <vehicle-model class="vehica-results__field vehica-relation-field vehica-results__field--relation_show"
                                   :value="model"
                                   :makes="makes"
                                   :multiselect="true"
                                   :in-stock="inStock"
                                   @input="toggleModel"></vehicle-model>
                    <div class="vehica-results__field vehica-relation-field vehica-results__field--relation_show">
                        <h4 class="vehica-results__field__label">
                            Body
                        </h4>
                        <div :class="'dropdown' + (body ? ' selected' : '')">
                            <button class="btn form-control dropdown-toggle" type="button" id="search-body" data-bs-toggle="dropdown" aria-expanded="false">
                                {{ body || 'Body Type' }}
                            </button>
                            <span v-if="body" class="vehica-form-button__clear vehica-form-button__clear--list" @click="clear('body')"><i class="fas fa-times"></i></span>
                            <ul class="dropdown-menu" aria-labelledby="search-body">
                                <li v-for="option in bodies" :key="option.id">
                                    <a :class="'dropdown-item' + isActive(option, body)" href="" @click.prevent="toggleBody(option)">{{ option.id }}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="vehica-results__field vehica-relation-field vehica-results__field--relation_show">
                        <h4 class="vehica-results__field__label">
                            Fuel Type
                        </h4>
                        <div :class="'dropdown' + (fuel?.length ? ' selected' : '')">
                            <button class="btn form-control dropdown-toggle" type="button" id="fuel-type" data-bs-toggle="dropdown" aria-expanded="false">
                                {{ fuel?.join(', ') || 'Fuel Type' }}
                            </button>
                            <span v-if="fuel?.length" class="vehica-form-button__clear vehica-form-button__clear--list" @click="clear('fuel')"><i class="fas fa-times"></i></span>
                            <ul class="dropdown-menu" aria-labelledby="fuel-type">
                                <li v-for="option in fueltypes" :key="option.id">
                                    <a :class="'dropdown-item' + isActive(option, fuel)" href="" @click.prevent="toggleFuel(option)">
                                        <i :class="'fa fa-fw fa-check me-2' + isVisible(option, fuel)"></i>
                                    {{ option.id }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="vehica-results__field vehica-results__field--price vehica-relation-field vehica-results__field--relation_show">
                        <div class="vehica-number-range">
                            <div :class="'vehica-number-range__1of2 vehica-number-range__1of2--left' + (minPrice ? ' vehica-active-number': '')">
                                <input placeholder="Min Price" type="text" name="minPrice" v-model="minPrice" inputmode="numeric" @keypress="numberOnly" @change="changed" onfocus="this.select()">
                                <span v-if="minPrice" class="vehica-form-button__clear vehica-form-button__clear--number-range" @click="clear('minPrice')"><i class="fas fa-times"></i></span>
                            </div>
                            <div :class="'vehica-number-range__1of2 vehica-number-range__1of2--right' + (maxPrice ? ' vehica-active-number': '')">
                                <input placeholder="Max Price" type="text" name="maxPrice" v-model="maxPrice" inputmode="numeric" @keypress="numberOnly" @change="changed" onfocus="this.select()">
                                <span v-if="maxPrice" class="vehica-form-button__clear vehica-form-button__clear--number-range" @click="clear('maxPrice')"><i class="fas fa-times"></i></span>
                            </div>
                        </div>
                    </div>
                    <div class="vehica-results__field vehica-results__field--number vehica-relation-field vehica-results__field--relation_show">
                        <div :class="'dropdown' + (miles ? ' selected' : '')">
                            <button class="btn form-control dropdown-toggle" type="button" id="search-miles" data-bs-toggle="dropdown" aria-expanded="false">
                                {{ mileageText }}
                            </button>
                            <span v-if="miles" class="vehica-form-button__clear vehica-form-button__clear--list" @click="clear('miles')"><i class="fas fa-times"></i></span>
                            <ul class="dropdown-menu" aria-labelledby="search-miles">
                                <li v-for="option in mileage" :key="option.id">
                                    <a :class="'dropdown-item' + isActive(option, miles)" href="" @click.prevent="toggleMiles(option)">{{ option.text }}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="vehica-results__field vehica-results__field--number vehica-relation-field vehica-results__field--relation_show">
                        <div class="vehica-number-range">
                            <div :class="'vehica-number-range__1of2 vehica-number-range__1of2--left' + (minYear ? ' vehica-active-number': '')">
                                <input placeholder="Min Year" type="text" name="minYear" v-model="minYear" maxlength="4" inputmode="numeric" @keypress="numberOnly" @change="changed" onfocus="this.select()">
                                <span v-if="minYear" class="vehica-form-button__clear vehica-form-button__clear--number-range" @click="clear('minYear')"><i class="fas fa-times"></i></span>
                            </div>
                            <div :class="'vehica-number-range__1of2 vehica-number-range__1of2--right' + (maxYear ? ' vehica-active-number': '')">
                                <input placeholder="Max Year" type="text" name="maxYear" v-model="maxYear" maxlength="4" inputmode="numeric" @keypress="numberOnly" @change="changed" onfocus="this.select()">
                                <span v-if="maxYear" class="vehica-form-button__clear vehica-form-button__clear--number-range" @click="clear('maxYear')"><i class="fas fa-times"></i></span>
                            </div>
                        </div>
                    </div>
                    <div class="vehica-results__field vehica-results__field--number vehica-relation-field vehica-results__field--relation_show">
                        <div class="vehica-number-range distance-from-zip">
                            <div class="dropdown vehica-number-range__1of2 vehica-number-range__1of2--left" :class="zipDistanceSelected">
                                <button class="btn form-control dropdown-toggle" type="button" id="search-miles" data-bs-toggle="dropdown" aria-expanded="false">
                                    {{ distanceText }}
                                </button>
                                <ul class="dropdown-menu" aria-labelledby="search-miles">
                                    <li v-for="m in [0, 10, 25, 50, 100, 200]" :key="m">
                                        <a :class="'dropdown-item' + (m === distance ? ' active' : '')" href="" @click.prevent="toggleDistance(m)">{{ milesOf(m) }}</a>
                                    </li>
                                </ul>
                            </div>
                            <div class="vehica-number-range__1of2 vehica-number-range__1of2--right" :class="zipDistanceActive">
                                <input type="text" :placeholder="distance?'Zip code':null" name="zip" v-model="zip" maxlength="5" inputmode="numeric"
                                       ref="zipInput"
                                       @keypress="numberOnly"
                                       @change="changed"
                                       :readonly="!distance"
                                       onfocus="this.select()">
                                <span v-if="zip && distance" class="vehica-form-button__clear vehica-form-button__clear--number-range" @click="clear('zip') || clear('distance')"><i class="fas fa-times"></i></span>
                            </div>
                        </div>
                    </div>
                    <div class="vehica-results__field vehica-relation-field vehica-results__field--relation_show">
                        <div class="d-flex">
                            <div class="w-50">
                                <div class="vehica-checkbox">
                                    <input id="my_likes" type="checkbox" v-model="likes" @change="changed">
                                    <label for="my_likes" class="vehica-relation-field__label">
                                        My Likes
                                    </label>
                                </div>
                            </div>
                            <div class="w-50">
                                <div class="vehica-checkbox">
                                    <input id="in_stock" type="checkbox" v-model="inStock">
                                    <label for="in_stock" class="vehica-relation-field__label">
                                        In Stock
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="vehica-results__fields__clear-load-more">
                        <div class="vehica-results__fields__clear" @click="clearall">
                            Clear all
                        </div>
                    </div>
                    <div class="vehica-results__fields__mobile-section-bottom">
                        <button class="vehica-button" @click="toggleMobileFilters(0)">
                            Apply
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="vehica-inventory-v1__middle">
            <div class="vehica-inventory-v1__title">
                {{ count }} {{ resultsText }}
            </div>
            <div class="vehica-inventory-v1__sort">
                <div class="vehica-inventory-v1__view">
                    <button :class="viewGridClass" title="Grid view" @click="toggleView('grid')"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><g transform="translate(-819 -493)"><rect data-name="Rectangle 5" width="9" height="8" rx="3" transform="translate(819 493)" fill="#888e95"></rect> <rect data-name="Rectangle 6" width="9" height="8" rx="3" transform="translate(830 493)" fill="#888e95"></rect> <rect data-name="Rectangle 7" width="9" height="8" rx="3" transform="translate(830 505)" fill="#888e95"></rect> <rect data-name="Rectangle 8" width="9" height="8" rx="3" transform="translate(819 505)" fill="#888e95"></rect></g></svg></button>
                    <button :class="viewListClass" title="Table view" @click="toggleView('list')"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="20" viewBox="0 0 25 20"><g transform="translate(-830 -493)"><rect data-name="Rectangle 6" width="25" height="8" rx="3" transform="translate(830 493)" fill="#888e95"></rect> <rect data-name="Rectangle 7" width="25" height="8" rx="3" transform="translate(830 505)" fill="#888e95"></rect></g></svg></button>
                </div>
                <div class="vehica-inventory-v1__sort__heading">
                    Sort by
                </div>
                <div class="vehica-inventory-v1__sort__select vehica-results__field">
                    <div class="dropdown">
                        <button class="btn form-control dropdown-toggle" type="button" id="search-sort-by" data-bs-toggle="dropdown" aria-expanded="false">
                            {{ sortByText }}
                        </button>
                        <ul class="dropdown-menu" aria-labelledby="search-sort-by">
                            <li v-for="option in sortOptions" :key="option.id">
                                <a :class="'dropdown-item' + isActive(option, sortBy)" href="" @click.prevent="toggleSortBy(option)">{{ option.text }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- Listing results -->
        <div v-if="view === 'grid'">
            <div class="vehica-inventory-v1__results" v-for="(r, i) in results" :key="i" v-html="r"></div>
        </div>
        <div v-else class="vehica-inventory-v1__2-cols">
            <div class="vehica-inventory-v1__2-cols__left">
                <div v-for="(r, i) in results" :key="i" class="vehica-inventory-v1__row-grid" v-html="r"></div>
            </div>
        </div>
        <div v-show="backToTop"
             class="back-to-top">
            <a href=""
               title="Back to top"
               @click.prevent="scrollToTop">
                <i class="fa fa-arrow-alt-circle-up fa-3x"></i>
            </a>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import VehicleMake from '../common/fields/VehicleMake';
    import VehicleModel from '../common/fields/VehicleModel';

    let controller = null;
    let d = new Date();
    const currentCentury = (d.getFullYear() - (d.getFullYear() % 1000));
    function calcMinMax(v1, v2, aMin, aMax) {
        if (v1 && v2) {
            if (v1 < v2) {
                aMin(v1);
                aMax(v2);
            } else {
                aMin(v2);
                aMax(v1);
            }
        }
    }

    function nonZero(value) {
        return (1 * value) ? 1 * value : null;
    }

    function nonEmpty(value) {
        return (value) ? value : null;
    }

    export default {
        props: ['values'],
        components: {
            VehicleMake,
            VehicleModel,
        },
        data: function () {
            return {
                backToTop: false,
                body: null,
                bodies: [
                    { id: 'Coupe' },
                    { id: 'Hatchback' },
                    { id: 'Minivan' },
                    { id: 'Sedan' },
                    { id: 'SUV' },
                    { id: 'Truck' },
                ],
                count: 0,
                distance: 0,
                filters: 0,
                fuel: [],
                fueltypes: [
                    { id: 'Diesel' }, 
                    { id: 'Electric' },
                    { id: 'Flex fuel' },
                    { id: 'Gasoline' },
                    { id: 'Hybrid' },
                    { id: 'Natural Gas'}
                ],
                init: true,
                inStock: true,
                loading: false,
                more: false,
                likes: false,
                keywords: null,
                make: null,
                makes: [],
                maxPrice: null,
                minPrice: null,
                maxYear: null,
                minYear: null,
                miles: null,
                mileage: [
                    { id: 10000, text: '< 10,000 miles' },
                    { id: 20000, text: '< 20,000 miles' },
                    { id: 30000, text: '< 30,000 miles' },
                    { id: 40000, text: '< 40,000 miles' },
                    { id: 50000, text: '< 50,000 miles' },
                    { id: 60000, text: '< 60,000 miles' },
                    { id: 70000, text: '< 70,000 miles' },
                    { id: 80000, text: '< 80,000 miles' },
                    { id: 90000, text: '< 90,000 miles' },
                    { id: 100000, text: '< 100,000 miles' },
                    { id: 120000, text: '< 120,000 miles' },
                    { id: 150000, text: '< 150,000 miles' },
                    { id: 200000, text: '< 200,000 miles' },
                    { id: null, text: 'Any mileage' },
                ],
                mobileFilters: false,
                model: null,
                paging: {
                    active: 0,
                    pageCount: 1
                },
                results: [],
                sortBy: 'featured',
                sortOptions: [
                    { id: 'featured', text: 'Most Relevant' },
                    { id: 'newest', text: 'Newest Listing' },
                    { id: 'price-low-to-high', text: 'Price: Low to high' },
                    { id: 'price-high-to-low', text: 'Price: High to low' },
                ],
                view: 'grid',
                viewType: 'grid',
                vin: '',
                zip: '',
            }
        },
        computed: {
            distanceText() {
                return this.milesOf(this.distance);
            },
            mileageText() {
                const id = this.miles;
                return this.mileage.find(o => o.id === id)?.text ?? 'Any mileage';
            },
            moreFilters() {
                return this.more ? 'Hide filters' : 'Show filters';
            },
            resultsText() {
                return this.count === 1 ? 'Result' : 'Results';
            },
            sortByText() {
                const id = this.sortBy;
                return this.sortOptions.find(o => o.id === id).text;
            },
            viewGridClass() {
                return this.viewType === 'grid' ? 'vehica-inventory-v1__view__button-active' : null;
            },
            viewListClass() {
                return this.viewType !== 'grid' ? 'vehica-inventory-v1__view__button-active' : null;
            },
            zipDistanceActive() {
                return this.zip && this.distance ? 'vehica-active-number' : '';
            },
            zipDistanceSelected() {
                return this.zip && this.distance ? 'selected' : '';
            }
        },
        methods: {
            changed() {
                this.search();
            },
            clear(field) {
                this[field] = Array.isArray(this[field]) ? [] : null;
                this.search();
            },
            clearall() {
                this.body = null;
                this.distance = 0;
                this.fuel = [],
                this.keywords = null;
                this.likes = false;
                this.make = null;
                this.makes = [];
                this.maxPrice = null;
                this.maxYear = null;
                this.miles = null;
                this.minPrice = null;
                this.minYear = null;
                this.model = null;
                this.vin = null;
                this.zip = null;
                this.search();
            },
            isActive(option, value) {
                return ((Array.isArray(value) && value.includes(option.id)) || option.id === value) ? ' active' : '';
            },
            isVisible(option, value) {
                return ((Array.isArray(value) && value.includes(option.id)) || option.id === value) ? '' : ' invisible';
            },
            milesOf(d) {
                return d ? 'Within ' + d + ' miles of' : 'Anywhere';
            },
            numberOnly(event) {
                if (!event.keyCode || event.keyCode < 48 || event.keyCode > 57) {
                    event.preventDefault();
                }
            },
            scrollToTop() {
                document.scrollingElement.scrollTo(0, 0, { smooth: true });
            },
            search(next) {
                const vm = this;
                let offset = 0;
                if (next) {
                    if (vm.loading) return;
                    vm.paging.active++;
                    if (vm.paging.active >= vm.paging.pageCount) {
                        return;
                    }
                    offset = vm.paging.active;
                } else {
                    controller?.abort();
                }
                if (vm.maxYear) {
                    vm.maxYear = 1 * vm.maxYear;
                    if (vm.maxYear < 100) vm.maxYear += currentCentury;
                }
                if (vm.minYear) {
                    vm.minYear = 1 * vm.minYear;
                    if (vm.minYear < 100) vm.minYear += currentCentury;
                }
                calcMinMax(vm.minYear, vm.maxYear, (min) => { vm.minYear = min }, (max) => { vm.maxYear = max });
                calcMinMax(vm.minPrice, vm.maxPrice, (min) => { vm.minPrice = min }, (max) => { vm.maxPrice = max });
                const data = {
                    body: vm.body,
                    distance: vm.distance,
                    fuel: vm.fuel.join(','),
                    keywords: vm.keywords,
                    likes: vm.likes,
                    make: vm.make,
                    miles: 1 * vm.miles ?? 0,
                    model: vm.model,
                    sortBy: vm.sortBy,
                    viewType: vm.viewType,
                    vin: vm.vin,
                    zip: vm.zip,
                    maxPrice: 1 * vm.maxPrice ?? 0,
                    minPrice: 1 * vm.minPrice ?? 0,
                    maxYear: 1 * vm.maxYear ?? 0,
                    minYear: 1 * vm.minYear ?? 0,
                    offset,
                };
                vm.loading = true;
                controller = new AbortController();
                axios.post('/search/results', data, { signal: controller.signal }).then(r => {
                    vm.count = r.data.resultsCount;
                    vm.paging = r.data.paging;
                    vm.filters = r.data.filters;
                    vm.more = vm.more || !!vm.filters;
                    if (vm.paging.active) {
                        vm.results.push(r.data.results);
                    } else {
                        vm.results = [r.data.results];
                    }
                    vm.view = vm.viewType;
                    window.history.pushState(null, null, r.data.url);
                    vm.init = false;
                })
                .catch(()=>{})
                .finally(() => {
                    vm.loading = false;
                });
            },
            toggleBody(option) {
                this.body = option.id;
                this.search();
            },
            toggleDistance(distance) {
                this.distance = distance;
                if (!distance) {
                    this.zip = '';
                } else {
                    this.$nextTick(() => this.$refs.zipInput.focus());
                }
                if (this.zip && distance) {
                    this.search();
                }
            },
            toggleFilters() {
                this.more = !this.more;
            },
            toggleFuel(option) {
                if (this.fuel.includes(option.id))
                    this.fuel.splice(this.fuel.indexOf(option.id), 1);
                else
                    this.fuel.push(option.id);
                this.search();
            },
            toggleMakes(makes) {
                if (!this.init) {
                    this.make = makes.map(m => m.id).join(',');
                }
                this.makes = makes;
                this.search();
            },
            toggleMiles(option) {
                this.miles = option.id;
                this.search();
            },
            toggleMobileFilters(show) {
                this.more = !!show;
                this.mobileFilters = !!show;
            },
            toggleModel(list) {
                this.model = list?.map(m => m.id).join(',');
                this.search();
            },
            toggleSortBy(option) {
                this.sortBy = option.id;
                this.search();
            },
            toggleView(type) {
                this.viewType = type;
                this.search();
            },
        },
        created() {
            this.count = 1 * this.values.count;
            this.sortBy = this.values.sort;
            this.viewType = this.values.view;
            this.body = nonEmpty(this.values.body);
            this.distance = 1 * this.values.distance;
            this.fuel = (this.values.fuel ?? '').split(',').filter(s => s);
            this.keywords = nonEmpty(this.values.keywords);
            this.likes = !!this.values.likes;
            this.make = nonEmpty(this.values.make);
            this.miles = nonZero(this.values.miles);
            this.model = nonEmpty(this.values.model);
            this.vin = nonEmpty(this.values.vin);
            this.zip = nonEmpty(this.values.zip);
            this.maxPrice = nonZero(this.values.maxprice);
            this.minPrice = nonZero(this.values.minprice);
            this.maxYear = nonZero(this.values.maxyear);
            this.minYear = nonZero(this.values.minyear);

            const vm = this;
            document.addEventListener('scroll', () => {
                let e = document.scrollingElement;
                if (e.scrollTop + e.clientHeight + 560 >= e.scrollHeight) {
                    vm.search(1);
                }

                vm.backToTop = e.scrollTop > 500;
            });
        }
    }
</script>